import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/dashboard/Sidebar/Sidebar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu/DropdownMenu";
import { useAuth } from "@/context/authContext";
import { useView } from "@/context/viewContext";
import {
  ChevronsUpDown,
  GraduationCap,
  IdCardLanyard,
  MonitorCog,
  Presentation,
  Undo2,
} from "lucide-react";
import styles from "./ViewSwitcher.module.css";
import { useIsMobile } from "@/hooks/useIsMobile";
import { HStack } from "@/components/layout/HStack";
import { VStack } from "@/components/layout/VStack";

const ViewSwitch = () => {
  const isMobile = useIsMobile();
  const { viewAs, setViewAs } = useView();
  const { state } = useAuth();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton className={styles.trigger}>
              <HStack align="center">
                <div className={styles.avatar}>
                  {viewAs === "sys-admin" ? (
                    <MonitorCog />
                  ) : viewAs === "administrator" ? (
                    <IdCardLanyard />
                  ) : viewAs === "teacher" ? (
                    <Presentation />
                  ) : viewAs === "student" ? (
                    <GraduationCap />
                  ) : (
                    ""
                  )}
                </div>
                <VStack gap={0} align="flex-start">
                  <span className={styles.viewingAs}>Viewing As</span>
                  <span className={styles.viewText}>
                    {viewAs === "sys-admin"
                      ? "System Admin"
                      : viewAs === "administrator"
                        ? "Administrator"
                        : viewAs === "teacher"
                          ? "Teacher"
                          : viewAs === "student"
                            ? "Student"
                            : ""}
                  </span>
                </VStack>
              </HStack>
              <ChevronsUpDown style={{ marginLeft: "auto" }} />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="start"
            side={isMobile ? "bottom" : "right"}
            style={{
              width: "var(--radix-dropdown-menu-trigger-width)",
              minWidth: "14rem",
            }}
          >
            {state.user!.role === "sys-admin" && (
              <DropdownMenuItem onClick={() => setViewAs("sys-admin")}>
                <div className={styles.menuItemWrapper}>
                  <MonitorCog />
                </div>
                System Administrator
              </DropdownMenuItem>
            )}
            {(state.user!.role === "sys-admin" ||
              state.user!.role === "administrator") && (
              <DropdownMenuItem onClick={() => setViewAs("administrator")}>
                <div className={styles.menuItemWrapper}>
                  <IdCardLanyard />
                </div>
                Administrator
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={() => setViewAs("teacher")}>
              <div className={styles.menuItemWrapper}>
                <Presentation />
              </div>
              Teacher
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setViewAs("student")}>
              <div className={styles.menuItemWrapper}>
                <GraduationCap />
              </div>
              Student
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => setViewAs(state.user!.role)}>
              <div className={styles.menuItemWrapper}>
                <Undo2 />
              </div>
              Back to Default
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};

export { ViewSwitch };
